module.exports = __webpack_public_path__ + "img/footer-instagram.9e0e2282.svg";